export const BULLET_ICON_SRC = 'https://acko-cms.ackoassets.com/Vector_2de8c36b64.svg'
